import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _ContractArticleItem } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';



interface Props {
    idAdquisitionContract: any;
    onChange: Function;
    label?: string;
}

export const EditorContractArticles = ({ idAdquisitionContract, onChange, label }: Props) => {

    const { instance, setLista, lista, setBean, bean } = useDataBean(_ContractArticleItem)

    const [valor, setValor] = useState<string>();
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (idAdquisitionContract) {
            getLista();
        }
    }, [idAdquisitionContract])

    const getLista = () => {
        instance.getContractArticleItemList(idAdquisitionContract).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID Artículo', property: 'IDContractArticleItem', visible: false },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Tipo de Bien', property: 'TypeName', visible: true },
        { title: 'Valor Contratado', property: 'ContractedValue', visible: true },
        { title: 'Valor a agregar', property: 'value', visible: true },
    ]

    const getItem = () => {
        if (bean.IDContractArticleItem) {
            setModal({ ...modal, "view": false })
            setValor(`$${_single.formatMoney(bean.ContractedValue)} - ${bean.Description} - ${bean.BudgetJsconCode} ${bean.BudgetName}`);
            onChange(bean)
        } else {
            toast.error("Documento no valido")
        }
    }

    return (
        <>
            <label>{label ?? "Articulo Seleccionado"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Seleccion de Articulo" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                </div>
            </Modal>
        </>
    )
}